import { render, staticRenderFns } from "./BatchOptimization.vue?vue&type=template&id=87965680&scoped=true"
import script from "./BatchOptimization.vue?vue&type=script&lang=js"
export * from "./BatchOptimization.vue?vue&type=script&lang=js"
import style0 from "./BatchOptimization.vue?vue&type=style&index=0&id=87965680&prod&lang=less"
import style1 from "./BatchOptimization.vue?vue&type=style&index=1&id=87965680&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87965680",
  null
  
)

export default component.exports